/** @format */

import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    height: 500,
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    p: 1,
 "@media (max-width: 767px)": {
    width: "90%",   
    height: "auto",
  },
};

export default function WatchVideo({ openDemoModel, handleClose }) {
    return (
        <div>
            <Modal
                open={openDemoModel}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box sx={{ mt: 2 }}>
                        <iframe
                            src="https://player.vimeo.com/video/1054674815?h=b6322233c7&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                            frameborder="0"
                            width="100%"
                            height="500"
                            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                            title="ezClocker Application Overview"
                        ></iframe>

                        <script src="https://player.vimeo.com/api/player.js"></script>
                        <Button
                            onClick={handleClose}
                            sx={{
                                position: 'absolute',
                                top: '0px',
                                right: '0px',
                                padding: 1,
                                color: '#000',
                                minWidth: 'auto',
                            }}
                        >
                            x
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
}
